import { observable } from "mobx";

export default class UserConvertStore {
  @observable modalVisible = false;
  @observable convertTypeSelected = {};
  @observable successCb = () => { }

}